<template>
  <div class="ren-decoration-cp ren-decoration-cp-wallet-card">
    <header>
      <div>
        <strong>{{ title }}</strong>
      </div>
      <button type="button" :style="linkStyle">{{ buttonText }}</button>
    </header>
    <div v-if="metrics.length" class="ren-decoration-cp-wallet-card__metrics">
      <span v-for="metric in metrics" :key="metric.label">
        <strong>{{ metric.value }}</strong>
        <small>{{ metric.label }}</small>
      </span>
    </div>
    <p v-else class="ren-decoration-cp-wallet-card__empty">暂无账户数据</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { previewBoundString, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const data = computed(() => previewDataRecord(props.componentData))
const title = computed(() =>
  previewBoundString(props.component, props.componentData, 'title', stringValue(props.component.props?.title, '我的钱包'))
)
const buttonText = computed(() => stringValue(props.component.props?.buttonText, '查看明细'))
const metrics = computed(() => {
  const rows = [
    { label: '余额', key: 'balance' },
    { label: '优惠券', key: 'coupons' },
    { label: '积分', key: 'points' }
  ]
  return rows
    .map((row) => ({ label: row.label, value: stringValue(data.value[row.key]) }))
    .filter((row) => row.value !== '')
})
const linkStyle = computed(() => ({
  color: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)'
}))
</script>

<style scoped>
.ren-decoration-cp-wallet-card {
  background: transparent;
}

.ren-decoration-cp-wallet-card__empty {
  margin: 0;
  color: var(--ren-theme-muted);
  font-size: 12px;
}
</style>
